define({
    root: ({
        windowOpenTitle: "Open Window",
        openBlockedMessage: "Pop-up window blocked.",
        titledOpenBlockedMessage: "{placeholder} window blocked.",
        unableToOpenMessage: "Unable to open window", // Used only when running in CEF rather than browser
        openPermissionRequest: "Do you want to open this window?",
        allowPopupsInstruction: "To open pop-up windows automatically, configure your browser to allow pop-ups from this site.",
        open: "Open"
    })
});